// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2kS2s","paramInput":"JobSimulator_paramInput__pHmpA","input":"JobSimulator_input__2P1LR"};